<app-progress-bar *ngIf="loading"></app-progress-bar>
<div *ngIf="!loading" class="row mt-1">
    <div class="col-lg-4 offset-lg-4">
        <div class="card  mb-3" style="max-width: 25rem;">
            <div class="card-header text-center">{{ operacion }} Práctica</div>
            <div class="card-body">
                <form [formGroup]="form" (ngSubmit)="addPractice()">
                    <table class="table mt-2">
                        <thead class="bg-primary  text-white">
                            <tr>
                                <th>Gestión</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let managment of managments" [class.selected]="managment.id === form.get('idmanagment')?.value" (click)="selectManagment(managment)">
                                <td>{{ managment.name }}</td>
                            </tr>
                        </tbody>
                    </table>
                    
                    <table class="table mt-2">
                        <thead class="bg-primary  text-white">
                            <tr>
                                <th>Nombre Carrera</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let career of careers" [class.selected]="career.id === form.get('idcareer')?.value" (click)="selectCareer(career)">
                                <td>{{ career.name }}</td>
                            </tr>
                        </tbody>
                    </table>
                    
                    <!--<table class="table">
                        <thead class="bg-primary  text-white">
                            <tr>
                                <th>Nombre Centro</th>
                            </tr>
                        </thead>
                        <tbody >
                            <tr *ngFor="let center of centers   " [class.selected]="center.id === form.get('idcenter')?.value" (click)="selectCenter(center)">
                                <td>{{ center.name }}</td>
                            </tr>
                            
                        </tbody>
                    </table>-->
                    <table class="table mt-2">
                        <thead class="bg-primary  text-white">
                            <tr>
                                <th>Nombre Area</th>
                                <th>Nombre Centro</th>
                                <th>Nombre Turno</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let areacenter of listAreaCenters" [class.selected]="areacenter.id === form.get('idareacenterturn')?.value" (click)="selectAreaCenterTurn(areacenter)">
                                <td>{{ areacenter.namearea }}</td>
                                <td>{{ areacenter.namecenter }}</td>
                                <td>{{ areacenter.nameturn }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <input formControlName="quota" type="number" class="form-control" placeholder="Ingrese la cantidad de cupos">
                    <span *ngIf="form.get('quota')?.hasError('required') && form.get('quota')?.touched">
                        El campo cupos es <strong>requerido</strong>
                    </span>
                    
                   <!-- <table class="table mt-2">
                        <thead class="bg-primary  text-white">
                            <tr>
                                <th>ID</th>
                                <th>Turno</th>
                            </tr>
                        </thead>
                        <tbody >
                            <tr *ngFor="let turn of turns" [class.selected]="turn.id === form.get('idturn')?.value" (click)="selectTurn(turn)">
                                <td>{{ turn.id }}</td>
                                <td>{{ turn.name }}</td>
                            </tr>
                            
                        </tbody>
                    </table>-->
                    
                    <div class="row mt-2 text-center">
                        <div class="col-lg-6">
                            <button routerLink="/practice" type="button" class="btn btn-secondary">Volver</button>
                        </div>
                        <div class="col-lg-6">
                            <button [disabled]="form.invalid" type="submit" class="btn btn-primary">Aceptar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
